'use client';

import AppLayout from '@/components/AppLayout';
import NouveauLocalContent from './components/NouveauLocalContent';

export default function NouveauLocalPage() {
  return (
    <AppLayout currentPath="/liste-des-locaux">
      <NouveauLocalContent mode="create" />
    </AppLayout>
  );
}
